
import './style.scss';
import { useEffect } from 'react';
import { Logout, Tune, AccountCircle, Lock, Business } from "@mui/icons-material";
import { Avatar, Box, Dialog, Divider, ListItemIcon, MenuItem, Typography } from "@mui/material";
import { useLanguageContext } from '../../contexts/LanguageContext';
import { useAuthContext } from '../../contexts/AuthContext';
import PreferencesDialog from './PreferencesDialog';
import ChangePasswordDialog from './ChangePasswordDialog';
import MyProfileDialog from './MyProfileDialog';
import ChangeEnterpriseDialog from './ChangeEnterpriseDialog';
import useDialog from '../../hooks/useDialog';


interface IProfileMenuProps {
    open: boolean;
    handleClose: () => void;
    handleOpenLogoutDialog: () => void;
    openPreferences: boolean;
    handleClosePreferences: () => void;
}


const ProfileMenu: React.FC<IProfileMenuProps> = ({ 
    open,
    handleClose,
    handleOpenLogoutDialog,
    openPreferences,
    handleClosePreferences
}) => {
    const { translate } = useLanguageContext();
    const { user, enterprise } = useAuthContext();

    const changePasswordDialog = useDialog();
    const preferencesDialog = useDialog();
    const myProfileDialog = useDialog();
    const changeEnterpriseDialog = useDialog();
    
    const enableChangeEnterpriseDialog = user?.enterprises && user.enterprises.length > 1;


    useEffect(() => {
        if (openPreferences) {
            preferencesDialog.handleOpen();
        }
        // eslint-disable-next-line
    }, [openPreferences]);


    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                PaperProps={{
                    className: 'paper-profilemenu'
                }}
            >
                <Box component='div' className='box-userprofile'>
                    <Avatar 
                        alt={user?.fullName.toUpperCase()} 
                        src={user?.avatar} 
                        className='avatar-userimage'
                    />
                    
                    <Typography variant='subtitle1' component='h5' className='text-title'> {user?.fullName} </Typography>
                    <Typography variant='subtitle2' component='h6' className='text-subtitle'> {enterprise?.name} </Typography>
                </Box>

                <Divider className='divider-menuitem' />

                <MenuItem className='menuitem-profileitem' onClick={() => changePasswordDialog.handleOpen()}>
                    <ListItemIcon>
                        <Lock fontSize="small" />
                    </ListItemIcon>

                    {translate('changePassword')}
                </MenuItem>

                <MenuItem className='menuitem-profileitem' onClick={() => myProfileDialog.handleOpen()}>
                    <ListItemIcon>
                        <AccountCircle fontSize="small" />
                    </ListItemIcon>

                    {translate('myProfile')}
                </MenuItem>

                <MenuItem className='menuitem-profileitem' onClick={() => preferencesDialog.handleOpen()}>
                    <ListItemIcon>
                        <Tune fontSize="small" />
                    </ListItemIcon>

                    {translate('preferences')}
                </MenuItem>

                {
                    enableChangeEnterpriseDialog && (
                        <MenuItem className='menuitem-profileitem' onClick={() => changeEnterpriseDialog.handleOpen()}>
                            <ListItemIcon>
                                <Business fontSize="small" />
                            </ListItemIcon>

                            {translate('changeEnterprise')}
                        </MenuItem>
                    )
                }

                <Divider className='divider-menuitem' />
                
                <MenuItem className='menuitem-profileitem logout' onClick={handleOpenLogoutDialog}>
                    <ListItemIcon>
                        <Logout fontSize="small" />
                    </ListItemIcon>
                    
                    {translate('logout')}
                </MenuItem>
            </Dialog>
            
            <ChangePasswordDialog 
                title={translate('changePassword')} 
                open={changePasswordDialog.open} 
                handleClose={() => changePasswordDialog.handleClose()} 
            />
            
            <MyProfileDialog 
                title={''} 
                open={myProfileDialog.open} 
                handleClose={() => myProfileDialog.handleClose()} 
            />
            
            <PreferencesDialog 
                title={translate('preferences')} 
                open={preferencesDialog.open} 
                handleClose={() => {
                    preferencesDialog.handleClose();
                    handleClosePreferences();
                }} 
            />

            {
                enableChangeEnterpriseDialog && (
                    <ChangeEnterpriseDialog
                        open={changeEnterpriseDialog.open}
                        handleClose={() => changeEnterpriseDialog.handleClose()}
                    />
                )
            }
        </>
    );
}

export default ProfileMenu;